import React from "react";
import { useModal } from "../../context/ModalContext";

const ModalModalidades = ({ data }) => {
  const { closeModal } = useModal();

  // Único caminho para concluir a leitura: confirma e já marca o checkbox.
  const handleAgree = () => {
    data?.onAgree?.();
    closeModal();
  };

  return (
    <div className="ModalModalidades" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-11">
            <h2 className="text-center mb-4">
              <strong>Como funciona cada modalidade</strong>
            </h2>

            <div className="mb-4">
              <h4>
                <strong>▸ Pedido Único</strong>
              </h4>
              <ul>
                <li>Pagamento único (cartão ou Pix).</li>
                <li>Sem cobrança automática.</li>
                <li>Você decide quando comprar de novo.</li>
              </ul>
            </div>

            <div className="mb-4">
              <h4>
                <strong>▸ Assinatura Trimestral — 10% off</strong>
              </h4>
              <ul>
                <li>O valor dos 3 meses é cobrado na contratação.</li>
                <li>Você recebe 1 pedido por mês, até a próxima cobrança.</li>
                <li><strong>Renovação automática com nova cobrança a cada 3 meses,</strong> se você não cancelar antes.</li>
                <li>O desconto de 10% vale ao cumprir os 3 meses do plano.</li>
                <li>Cancelou antes de concluir os 3 meses? As remessas não produzidas são estornadas com retenção de 20% de multa. Pedidos em produção, já enviados ou entregues não são estornados.</li>
              </ul>
            </div>

            <div className="mb-4">
              <h4>
                <strong>▸ Assinatura Anual — 20% off</strong>
              </h4>
              <ul>
                <li>O valor dos 12 meses é cobrado na contratação.</li>
                <li>Você recebe 1 pedido por mês, até a próxima cobrança.</li>
                <li><strong>Renovação automática com nova cobrança a cada 12 meses,</strong> se você não cancelar antes.</li>
                <li>O desconto de 20% vale ao cumprir os 12 meses do plano.</li>
                <li>Cancelou antes de concluir os 12 meses? As remessas não produzidas são estornadas com retenção de 20% de multa. Pedidos em produção, já enviados ou entregues não são estornados.</li>
              </ul>
            </div>

            <div className="mb-4">
              <h4>
                <strong>▸ Alteração de sabores</strong>
              </h4>
              <p>Você pode alterar os sabores até 5 dias após receber cada pedido.</p>
            </div>

            <div className="mb-2">
              <h4>
                <strong>▸ Aviso</strong>
              </h4>
              <p>Enviamos um aviso para seu email dias antes da renovação da sua assinatura.</p>
            </div>

            <div className="text-center mt-4 mb-2">
              <button type="button" className="btn btn-purissima" onClick={handleAgree}>
                Li e concordo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalModalidades;
